import React from "react";
import { Marker, Popup } from "react-leaflet";
import L from "leaflet";
import moment from "moment-timezone";
import { Button } from "react-bootstrap";
import "./EarthquakeMarkers.css";
export default function EarthquakeMarkersRIMES({
  reEqdata = [],
  compute_magnitude,
  getDistance,
  handleShowModal,
  setClickedEventElement,
  setShowLanguageModal,
  markerRefs,
  canSendEmail = false,
  canGenerateBulletin = false,
}) {
  const icon = L.icon({
    iconUrl: "/Earthquake/recent.png",
    iconSize: [30, 30],
  });

  return (
    <>
      {reEqdata.map((eqs, index) => {
        const t = compute_magnitude(parseFloat(eqs.magnitude));
        const distance_each = getDistance(eqs.latitude, eqs.longitude);

        if (index === 0) {
          return (
            <Marker
              key={index}
              position={[eqs.latitude, eqs.longitude]}
              icon={icon}
              ref={(el) => (markerRefs.current[index] = el)}
            >
              <Popup className="custom-popup-class">
                <h2 className="tbTit">{eqs.region}</h2>
                Date and Time :{" "}
                {moment
                  .utc(eqs.event_datetime)
                  .tz("Asia/Dili")
                  .format("DD MMM YYYY hh:mm:ss A") + " East Timor Time (TLT)"}
                <br />
                Longitude : {eqs.longitude}
                <br />
                Latitude : {eqs.latitude}
                <br />
                Magnitude : {eqs.magnitude} {eqs.mag_type}
                <br />
                Depth : {eqs.depth} km
                <br />
                Distance : {distance_each}
                <br />
                {canSendEmail && (
                <Button
                  variant="info"
                  onClick={handleShowModal}
                  data-source="RIMES"
                  data-reg={eqs.region}
                  data-time={`${moment
                    .utc(eqs.event_datetime)
                    .tz("Asia/Dili")
                    .format("DD MMM YYYY hh:mm:ss A [East Timor Time (TLT)]")}`}
                  data-mag={eqs.magnitude}
                  data-magt={eqs.mag_type}
                  data-long={eqs.longitude}
                  data-lat={eqs.latitude}
                  data-depth={eqs.depth}
                  data-info={`Region = ${eqs.region} \n Origin Time =${moment
                    .utc(eqs.event_datetime)
                    .tz("Asia/Dili")
                    .format(
                      "DD MMM YYYY hh:mm:ss A [East Timor Time (TLT)]"
                    )} \n Magnitude = ${eqs.magnitude} ${
                    (eqs.mag_type?.toLowerCase() === "mb" ? "SR" : eqs.mag_type)
                  } \n Depth = ${eqs.depth} km \n Longitude = ${
                    eqs.longitude
                  } \n Latitude = ${eqs.latitude} \n Source = RIMES`}
                  size="sm"
                >
                  Send Email
                </Button>
                )}{" "}
                {canGenerateBulletin && (
                <Button
                  variant="success"
                  onClick={(e) => {
                    setClickedEventElement(e.currentTarget);
                    setShowLanguageModal(true);
                  }}
                  data-source="RIMES"
                  data-reg={eqs.region}
                  data-time={`${moment
                    .utc(eqs.event_datetime)
                    .tz("Asia/Dili")
                    .format("DD MMM YYYY hh:mm:ss A [East Timor Time (TLT)]")}`}
                  data-mag={eqs.magnitude}
                  data-magt={eqs.mag_type}
                  data-long={eqs.longitude}
                  data-lat={eqs.latitude}
                  data-depth={eqs.depth}
                  className="bulletin-btn"
                  size="sm"
                >
                  Bulletin
                </Button>
                )}
              </Popup>
            </Marker>
          );
        } else {
          return (
            
            <Marker
              key={index}
              position={[eqs.latitude, eqs.longitude]}
              icon={L.divIcon({
                className: "animated-circle-icon",
                html: `
                    <div class="circle-container-eq" style="--circle-color: ${
                      t.color
                    }">
                        <div class="pulse-ring-eq"></div>
                        <div class="circle-center-eq">${eqs.magnitude.toFixed(
                          1
                        )}</div>
                    </div>
                    `,
                iconSize: [40, 40],
                iconAnchor: [20, 20],
              })}
              ref={(el) => (markerRefs.current[index] = el)}
            >
              <Popup className="custom-popup-class">
                <h2 className="tbTit">{eqs.region}</h2>
                Date and Time :{" "}
                {moment
                  .utc(eqs.event_datetime)
                  .tz("Asia/Dili")
                  .format("DD MMM YYYY hh:mm:ss A") + " East Timor Time (TLT)"}
                <br />
                Longitude : {eqs.longitude}
                <br />
                Latitude : {eqs.latitude}
                <br />
                Magnitude : {eqs.magnitude} {eqs.mag_type}
                <br />
                Depth : {eqs.depth} km
                <br />
                <br />
                {canSendEmail && (
                <Button
                  variant="info"
                  onClick={handleShowModal}
                  data-source="RIMES"
                  data-reg={eqs.region}
                  data-time={`${moment
                    .utc(eqs.event_datetime)
                    .tz("Asia/Dili")
                    .format("DD MMM YYYY hh:mm:ss A [East Timor Time (TLT)]")}`}
                  data-mag={eqs.magnitude}
                  data-magt={eqs.mag_type}
                  data-long={eqs.longitude}
                  data-lat={eqs.latitude}
                  data-depth={eqs.depth}
                  data-info={`Region = ${eqs.region} \n Origin Time =${moment
                    .utc(eqs.event_datetime)
                    .tz("Asia/Dili")
                    .format(
                      "DD MMM YYYY hh:mm:ss A [East Timor Time (TLT)]"
                    )} \n Magnitude = ${eqs.magnitude} ${
                    (eqs.mag_type?.toLowerCase() === "mb" ? "SR" : eqs.mag_type)
                  } \n Depth = ${eqs.depth} km \n Longitude = ${
                    eqs.longitude
                  } \n Latitude = ${eqs.latitude} \n Source = RIMES`}
                  size="sm"
                >
                  Send Email
                </Button>
                )}{" "}
                {canGenerateBulletin && (
                <Button
                  variant="success"
                  onClick={(e) => {
                    setClickedEventElement(e.currentTarget);
                    setShowLanguageModal(true);
                  }}
                  data-source="RIMES"
                  data-reg={eqs.region}
                  data-time={`${moment
                    .utc(eqs.event_datetime)
                    .tz("Asia/Dili")
                    .format("DD MMM YYYY hh:mm:ss A [East Timor Time (TLT)]")}`}
                  data-mag={eqs.magnitude}
                  data-magt={eqs.mag_type}
                  data-long={eqs.longitude}
                  data-lat={eqs.latitude}
                  data-depth={eqs.depth}
                  className="bulletin-btn"
                  size="sm"
                >
                  Bulletin
                </Button>
                )}
              </Popup>
            </Marker>
            // </Circle>
          );
        }
      })}
    </>
  );
}
